import { Route, Routes as RouterRoutes } from "react-router-dom";
import {
  About,
  Contact,
  Feedback,
  Home,
  Login,
  Members,
  NewsEvents,
  Privacy,
  Products,
  Signup,
} from "./pages";
import AdminDashboard from "./pages/admin/Dashboard";

export function Routes() {
  return (
    <RouterRoutes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/news-events" element={<NewsEvents />} />
      <Route path="/products" element={<Products />}>
        <Route path=":status" element={<Products />} />
      </Route>
      <Route path="/members" element={<Members />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/feedback" element={<Feedback />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/admin/*" element={<AdminDashboard />} />
    </RouterRoutes>
  );
} 